module.exports = __webpack_public_path__ + "static/019-5335c57d8c31c7e11d8c322742ccf560.jpg";